import Button from '@cobliteam/ui/components/Button';
import InfoBanner from '@cobliteam/ui/components/InfoBanner';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';

interface EditTemplateBannerProps {
  onClick(): void;
}

const EditTemplateBanner = ({ onClick }: EditTemplateBannerProps) => {
  return (
    <InfoBanner>
      <InfoBanner.Content>
        <InfoBanner.Icon icon={<Icon name='info' className='text-gray-dark' />} />
        <InfoBanner.Text>
          <Typography variant='caption-default' className='text-gray-dark'>
            Esta regra não te atende?
          </Typography>
        </InfoBanner.Text>
      </InfoBanner.Content>
      <InfoBanner.Actions>
        <Button variant='ghost' size='sm' onClick={onClick}>
          Editar regra
        </Button>
      </InfoBanner.Actions>
    </InfoBanner>
  );
};

export default EditTemplateBanner;
